import React, {   useEffect } from "react"; 
const Approach = (props) => {
     
    const s3URL = process.env.REACT_APP_AWS_S3_URL;
     
    function sociallink(link) {

        var reg = new RegExp("^(http|https)://", "i");

        var match = reg.test(link);
         
        if (match == true) {
            return link;
        }
        else {
            link = 'https://' + link;
            return link;
        }



    }
   
    useEffect(() => {
        
    }, [props.bindData]);
  return (
    <>
      {/* <!-- Approach Area --> */}
          <section className="section approach-section">
              <div className="container-fluid">
                  <div className="section-title text-center mb-5">
                      <h2>A different approach to <span className="text-theme">compliance support</span></h2>
                      <h4 className="section-desc mt-4" style={{fontSize: '18px'}}>Growing companies are stuck between costly consultants, generic freelance platforms, and software that still needs experts. Syncuppro was built to fill that gap.</h4>
                  </div>

                  <div className="row mb-5 align-items-center">
                      <div className="col-md-6 d-flex align-items-center justify-content-end approach-image-col" style={{ paddingRight: '32px' }}>
                          <div className="approach-block" style={{ width: '100%', height: '450px' }}>
                              <img src="images/office_staff_left_side.jpg" alt="right-sized" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          </div>
                      </div>
                      <div className="col-md-6 d-flex align-items-center justify-content-start approach-text-col" style={{ paddingLeft: '32px' }}>
                          <div className="approach-block text-start" style={{maxWidth: '640px', width: '100%', textAlign: 'left'}}>
                              <div className="d-flex align-items-start mb-3">
                                  <span className="material-icons text-theme m-r-10" style={{marginTop: '2px', fontSize: '32px'}}>groups</span>
                                  <h6 className="mb-0">Right-sized expertise, without consulting firm overhead</h6>
                              </div>
                              <p style={{ fontSize: '18px' }}>Traditional consulting firms sell long engagements and large teams. Syncuppro gives you access to the same experienced compliance professionals without enterprise pricing, long timelines, or fixed packages you do not need.</p>
                              <div className="d-flex align-items-start mb-3">
                                  <span className="material-icons text-theme m-r-10" style={{marginTop: '2px', fontSize: '32px'}}>verified_user</span>
                                  <h6 className="mb-0">Built for compliance, not general freelancing</h6>
                              </div>
                              <p style={{ fontSize: '18px' }}>Open freelance platforms mix compliance experts with millions of unrelated profiles and leave vetting to you. Syncuppro's experts are vetted, and the platform is focused entirely on standards and audits.</p>
                              <div className="d-flex align-items-start mb-3">
                                  <span className="material-icons text-theme m-r-10" style={{marginTop: '2px', fontSize: '32px'}}>settings</span>
                                  <h6 className="mb-0">Featuring the experts behind GRC software</h6>
                              </div>
                              <p style={{ fontSize: '18px' }}>GRC tools help track compliance, but they do not interpret standards, design controls, or pass audits. Our experts help you choose the right tools, configure them for your business, train your team, and guide you through certification.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
    </>
  );
};

export default Approach;
